export const authAPIConfig = {
  "aws_project_region": "us-west-2",
  "aws_appsync_graphqlEndpoint": "https://jq76vgdyszbmbn366j7ewtpnmu.appsync-api.us-west-2.amazonaws.com/graphql",
  "aws_appsync_region": "us-west-2",
  "aws_appsync_authenticationType": "API_KEY"
};

export const authenticateUserMutation = `
mutation authenticateUserMutation($input: AuthenticateUserInput!) {
  authenticateUser(input: $input) {
    authorizedModules
    credentials {
      AccessKeyId
      SecretAccessKey
      SessionToken
      Expiration
    }
    user
  }
}
`;

export const reauthenticateUserMutation = `
mutation reauthenticateUserMutation($input: ReauthenticateUserInput!) {
  reauthenticateUser(input: $input) {
    authorizedModules
    credentials {
      AccessKeyId
      SecretAccessKey
      SessionToken
      Expiration
    }
  }
}
`;

export const receiveScannedUIDSubscription = `
subscription receiveScannedUIDSubscription($serial: String!) {
  receiveScannedUID(serial: $serial) {
    serial
    uid
  }
}
`;

export const isValidBarcodeUserQuery = `
query isValidBarcodeUserQuery($barcode: String! $userType: String!) {
  isValidBarcodeUser(barcode: $barcode userType: $userType)
}
`;

export const setUserBarcodePinMutation = `
mutation setUserBarcodePinMutation($barcode: String!, $userType: String!, $pin: String!) {
  setUserBarcodePin(barcode: $barcode, userType: $userType, pin: $pin)
}
`;